import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=9f7915f4&"
import script from "./RoleList.js?vue&type=script&lang=js&"
export * from "./RoleList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports